import { render, staticRenderFns } from "./BlockPopupPropertyHistory.vue?vue&type=template&id=093fa905&scoped=true&"
import script from "./BlockPopupPropertyHistory.vue?vue&type=script&lang=js&"
export * from "./BlockPopupPropertyHistory.vue?vue&type=script&lang=js&"
import style0 from "./BlockPopupPropertyHistory.vue?vue&type=style&index=0&id=093fa905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093fa905",
  null
  
)

export default component.exports